import { render, staticRenderFns } from "./helpCentreNavItem.vue?vue&type=template&id=62c28905&scoped=true&"
import script from "./helpCentreNavItem.vue?vue&type=script&lang=js&"
export * from "./helpCentreNavItem.vue?vue&type=script&lang=js&"
import style0 from "./helpCentreNavItem.vue?vue&type=style&index=0&id=62c28905&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c28905",
  null
  
)

export default component.exports